module.exports = __webpack_public_path__ + "static/media/31179995_10.637b600e.jpg";